import React from 'react';
import { Alert } from 'react-bootstrap';
import { getClientRuntimeAvailability } from '../../features/aiRigging';

export default function RiggingRuntimeNotice({ availability, className = '' }) {
  const local = availability || getClientRuntimeAvailability();
  const mode = local.mode || local.runtime_availability?.mode || getClientRuntimeAvailability().mode;

  if (mode === 'executable') {
    return null;
  }

  const copy = {
    configuration_hidden: {
      variant: 'secondary',
      title: 'AI Rigging is not enabled',
      body: 'This environment has AI Rigging disabled.',
    },
    memory_disabled: {
      variant: 'secondary',
      title: 'Project Rig Memory is not enabled',
      body: 'Enable Project Rig Memory before creating rigging jobs.',
    },
    view_only: {
      variant: 'info',
      title: 'Job creation is disabled',
      body:
        'You can review Project Rig Memory and existing jobs, but new rigging jobs cannot be created in this environment.',
    },
    create_but_do_not_execute: {
      variant: 'warning',
      title: 'Rigging runtime is not enabled',
      body:
        'The Rigging Job workflow is available for configuration and review, but Maya and FabricatorStudio execution are not enabled in this environment.',
    },
  }[mode] || {
    variant: 'warning',
    title: 'Runtime availability',
    body: 'Maya execution may be limited in this environment.',
  };

  return (
    <Alert variant={copy.variant} className={className} data-testid="rigging-runtime-notice">
      <strong>{copy.title}</strong>
      <div>{copy.body}</div>
    </Alert>
  );
}
